<script lang="ts">
	import { onMount } from 'svelte';
	import { format } from 'svelte-i18n';
	import ControlCuryIntensity from './ControlCuryIntensity.svelte';
	import ControlOnOffAmbient from './ControlOnOffAmbient.svelte';
	import ControlCuryAwayMode from './ControlCuryAwayMode.svelte';
	import { navigateToCuryThirdPartyLogin } from '../../Lists/list-helpers';
	import { Alert } from '@Shelly/shelly-design-system';
	import {
		CURY_APP_PROMO_BANNER_ID,
		CURY_APP_PROMO_CTA_GO_TO_APP,
		CURY_APP_PROMO_SURFACE,
	} from 'src/helpers/banner_views/banner-ids';
	import {
		dismissBanner,
		isBannerVisible,
		markBannerSeen,
		trackBannerCta,
	} from 'src/helpers/banner_views/banner-views-helpers';
	import {
		clearCuryLegacyLocalStorage,
		ensureBannerViewsMigrations,
	} from 'src/helpers/banner_views/banner-views-migrate';

	export let device, status, settings;

	let showCuryAppPromo = false;

	onMount(async () => {
		await ensureBannerViewsMigrations();
		showCuryAppPromo = isBannerVisible(CURY_APP_PROMO_BANNER_ID, CURY_APP_PROMO_SURFACE);
		if (showCuryAppPromo) {
			void markBannerSeen(CURY_APP_PROMO_BANNER_ID, {
				scope: 'shared',
				surface: CURY_APP_PROMO_SURFACE,
			});
		}
	});

	const dismissCuryAppPromo = () => {
		showCuryAppPromo = false;
		clearCuryLegacyLocalStorage();
		void dismissBanner(CURY_APP_PROMO_BANNER_ID, {
			scope: 'shared',
			surface: CURY_APP_PROMO_SURFACE,
			dismissSource: 'user',
		});
	};

	const onCuryAppCta = () => {
		void trackBannerCta(CURY_APP_PROMO_BANNER_ID, CURY_APP_PROMO_CTA_GO_TO_APP, {
			scope: 'shared',
			surface: CURY_APP_PROMO_SURFACE,
		});
		navigateToCuryThirdPartyLogin('', true);
	};
</script>

{#if showCuryAppPromo}
	<Alert
		class="mb-s"
		type="info"
		heading={$format('cury_promo_heading', { default: 'Explore Cury app now!' })}
		message={$format('cury_promo_message', {
			default: 'Cury diffuser has its own dedicated app.',
		})}
		customIcon="fas fa-info text-primary"
		isHeadingBold
		dismissable
		on:dismissable_click={dismissCuryAppPromo}
		cta={{
			title: $format('link_go_to_cury_app', { default: 'Go to the app' }),
		}}
		on:cta_click={onCuryAppCta}
	/>
{/if}
<ControlOnOffAmbient {device} {status} {settings} />
<!-- ControlOnOffAmbient is a classic toggle control for the on/off state of the ambient light -->
<ControlCuryIntensity {device} {status} />
<!-- ControlCuryIntensity is a custom visualization and control for the intensity of the Cury device -->
<ControlCuryAwayMode {device} {status} />
<!-- ControlCuryAwayMode is a toggle control for the away mode -->
